export class FooterAnimation {
  private footer: HTMLElement | null = null;
  private sections: HTMLElement[] = [];
  private footerBottom: HTMLElement | null = null;
  private observer: IntersectionObserver | null = null;
  private hasAnimated: boolean = false;

  constructor() {
    this.footer = document.getElementById('animated-footer') as HTMLElement;
    if (!this.footer) {
      console.warn('⚠️ Footer element not found');
      return;
    }

    this.sections = Array.from(this.footer.querySelectorAll('.footer-section')) as HTMLElement[];
    this.footerBottom = this.footer.querySelector('.footer-bottom') as HTMLElement;

    this.setupScrollAnimation();
  }

  private setupScrollAnimation(): void {
    if (!this.footer) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.hasAnimated) {
            this.animateFooter();
            this.hasAnimated = true;
          }
        });
      },
      {
        threshold: 0.05, // Lower threshold for earlier trigger
        rootMargin: '0px 0px -50px 0px' // Trigger earlier for smoother entry
      }
    );

    this.observer.observe(this.footer);
  }

  private animateFooter(): void {
    if (!this.footer) return;
    
    // Use requestAnimationFrame for smoother animations
    requestAnimationFrame(() => {
      // Animate main footer container
      this.footer?.classList.add('visible');

      // Animate sections with staggered delay using requestAnimationFrame
      this.sections.forEach((section, index) => {
        const delay = index * 80; // Slightly longer delay for smoother feel
        setTimeout(() => {
          requestAnimationFrame(() => {
            section.classList.add('visible');
          });
        }, delay);
      });

      // Animate footer bottom after sections
      if (this.footerBottom) {
        const bottomDelay = this.sections.length * 80 + 150;
        setTimeout(() => {
          requestAnimationFrame(() => {
            this.footerBottom?.classList.add('visible');
          });
        }, bottomDelay);
      }
    });
  }

  public dispose(): void {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
}
